module.exports = __webpack_public_path__ + "img/l-hd.45d226ed.webp";